import React, { FC } from 'react';
import styled from 'styled-components';
import { DataTableQuickReports } from './DataTableAdvancedElements/DataTableQuickReports/Drawer/DataTableQuickReports';
import { PluginDestination } from './plugins/impl';
import { usePropsForwarderContext } from './plugins/impl/context/ForwarderContext';
import { DataTableQuickActionsProvider } from './utils/DataTableQuickActionsContext';
import { QuickReportsExportPanelInternalComponent } from './DataTableAdvancedElements/DataTableQuickReports/QuickReportsExportPanel/QuickReportsExportPanel';

export const DataTableTopSection: FC = () => {
  const { isEnabled } = usePropsForwarderContext();
  const hasQuickReports = isEnabled('quickReports');

  return (
    <StyledTopSections>
      <DataTableQuickActionsProvider>
        {hasQuickReports && <QuickReportsExportPanelInternalComponent />}
        <PluginDestination name="toolbar" />
        {hasQuickReports && <DataTableQuickReports />}
        <PluginDestination name="filters" />
      </DataTableQuickActionsProvider>
      <PluginDestination name="bulkActions" />
    </StyledTopSections>
  );
};

const StyledTopSections = styled.div`
  position: relative;
`;
